/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAnforderungAufgabenResponseDto } from '../../models/lexplus-anforderung-aufgaben-response-dto';

export interface ArchivierteAnforderungControllerGetArchivierteAnforderungAufgabenV1$Params {
  anforderungsversionID: number;
  erledigtLimit?: number;
}

export function archivierteAnforderungControllerGetArchivierteAnforderungAufgabenV1(http: HttpClient, rootUrl: string, params: ArchivierteAnforderungControllerGetArchivierteAnforderungAufgabenV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAnforderungAufgabenResponseDto>> {
  const rb = new RequestBuilder(rootUrl, archivierteAnforderungControllerGetArchivierteAnforderungAufgabenV1.PATH, 'get');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
    rb.query('erledigtLimit', params.erledigtLimit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAnforderungAufgabenResponseDto>;
    })
  );
}

archivierteAnforderungControllerGetArchivierteAnforderungAufgabenV1.PATH = '/v1/compliance/archiv/{anforderungsversionID}/aufgaben';
